import CreatePlannedMaintenanceBlankSidePage from '@/pages/Equipment/components/Maintenance/CreatePlannedMaintenanceBlankSidePage'
import CreateUnplannedMaintenanceBlankSidePage from '@/pages/Equipment/components/Maintenance/CreateUnplannedMaintenanceBlankSidePage'
import Timeline from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/components/Timeline'
import equipmentMaintenanceTableFields from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/equipmentMaintenanceTable.fields'
import useCreatePlannedMaintenanceBlankSidePageCtrl from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/hooks/useCreatePlannedMaintenanceBlankSidePageCtrl'
import useCreateUnplannedMaintenanceBlankSidePageCtrl from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/hooks/useCreateUnplannedMaintenanceBlankSidePageCtrl'
import useEquipmentMaintenanceTableCtrl from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/hooks/useEquipmentMaintenanceTableCtrl'
import useViewMaintenanceBlankSidePageCtrl from '@/pages/Equipment/components/Maintenance/EquipmentMaintenanceTable/hooks/useViewMaintenanceBlankSidePageCtrl'
import { IEquipment, IEquipmentMaintenanceBlank } from '@/pages/Equipment/equipment.types'
import MaintenanceBlankSidePage from '../EquipmentMaintenanceBlankSidePage'
import BadgeCount from '@/shared/Badges/BadgeCount'
import Button from '@/shared/Buttons/Button'
import Table from '@/shared/Tables/Table'
import useTableWithRequest from '@/shared/Tables/Table/ctrl/useTableWithRequest'
import PlusIcon from '../../../../../assets/icons/plus.svg?react'
import SearchInput from '@/shared/Inputs/SearchInput'
import AntDateRangePicker from '@/shared/Inputs/DatePickers/AntDateRangePicker'
import DropdownFilterChips from '@/shared/Inputs/FilterChips/DropdownFilterChips'
import maintenanceTypeDropdownConstants from '../MaintenanceTypeDropdown/maintenanceTypeDropdown.constants'

interface IProps {
  equipmentId: IEquipment['id']
}

const EquipmentMaintenanceTable = (props: IProps) => {
  const ctrl = useEquipmentMaintenanceTableCtrl(props.equipmentId)
  const createPlannedCtrl = useCreatePlannedMaintenanceBlankSidePageCtrl()
  const createUnplannedCtrl = useCreateUnplannedMaintenanceBlankSidePageCtrl()
  const viewBlankCtrl = useViewMaintenanceBlankSidePageCtrl(ctrl.data.items)

  const tableCtrl = useTableWithRequest<IEquipmentMaintenanceBlank>({
    serverSideOrder: false,
    fields: equipmentMaintenanceTableFields,
    tableKey: `${props.equipmentId}/maintenance-blanks`,
    itemKey: 'id',
    dataFetcher: ctrl.handlers.dataLoad,
    storageType: 'inMemory',
    items: ctrl.data.items,
    setItems: ctrl.handlers.setItems,
  })

  return (
    <>
      {createPlannedCtrl.blankSchema && (
        <CreatePlannedMaintenanceBlankSidePage
          open={createPlannedCtrl.open}
          blankSchema={createPlannedCtrl.blankSchema}
          equipmentId={props.equipmentId}
          processRuleId={createPlannedCtrl.processRuleId}
          onSuccess={ctrl.handlers.incrementTimelineKey}
          onClose={createPlannedCtrl.clearProcessRuleIdState}
        />
      )}
      <CreateUnplannedMaintenanceBlankSidePage
        open={createUnplannedCtrl.open}
        equipmentId={props.equipmentId}
        onClose={createUnplannedCtrl.handleClose}
      />
      <MaintenanceBlankSidePage
        blank={viewBlankCtrl.blank}
        open={viewBlankCtrl.open}
        onClose={viewBlankCtrl.clearBlankIdState}
      />
      <div className="flex-lines gap16">
        <div className="inline-flex-gap gap8 center">
          <h4 className="text-heading-4">Журнал обслуживания</h4>
          <BadgeCount type="default" count={tableCtrl.totalItemsCount} />
          <div style={{ marginLeft: '20px' }}>
            <Button
              size="default"
              type="primary"
              text="Добавить запись"
              icon={<PlusIcon className="text-white" />}
              onClick={createUnplannedCtrl.handleOpen}
            />
          </div>
        </div>
        <Timeline
          key={ctrl.data.timelineKey}
          equipmentId={props.equipmentId}
          onElementClick={createPlannedCtrl.handleProcessRuleIdChange}
        />
        <div className="inline-flex-gap gap8 width100">
          <div style={{ flexGrow: 1 }}>
            <SearchInput
              value={ctrl.data.filters.search}
              name="search"
              onChange={ctrl.handlers.handleFilterChange}
              placeHolder="Поиск по журналу обслуживания"
            />
          </div>
          <div style={{ width: '368px' }}>
            <AntDateRangePicker
              allowSelectInFuture={false}
              onChange={ctrl.handlers.handleDate}
              endTs={ctrl.data.filters.created_lte?.getTime()}
              startTs={ctrl.data.filters.created_gte?.getTime()}
              withTime={true}
            />
          </div>
          <div style={{ flexShrink: 0 }}>
            <DropdownFilterChips
              name="type"
              selectedOption={ctrl.data.filters.type}
              title="Тип обслуживания"
              options={maintenanceTypeDropdownConstants.options}
              style={{ minWidth: '140px' }}
              panelStyle={{ width: '280px', right: 0 }}
              onSelect={ctrl.handlers.handleFilterChange}
              emptySelectionLabel=""
            />
          </div>
        </div>
      </div>
      <Table
        {...tableCtrl}
        items={ctrl.data.items}
        itemKey="id"
        onClick={(blank) => {
          viewBlankCtrl.handleOpen(blank.id)
        }}
      />
    </>
  )
}

export default EquipmentMaintenanceTable
